'use strict';

var mcore = require('mcoreapp');
var __mc_T_El = mcore.virtualDom.Element;
var __mc_T_formatters = mcore.Template.formatters;
var __mc_T_binders = mcore.Template.binders;
var __mc_T_components = mcore.Template.components;
var __objectKeys = mcore.util.objectKeys;
var __each = mcore.util.each;
var __isArray = mcore.util.isArray;

module.exports = function(scope, __mc__observe) {
    var __mc__children_0 = [];
    var __mc__binders = {};
    var __mc__dom_id = 0;
    var __pathMap = {};

    var __getPath = function(path) {
        var key = path;
        if (__pathMap[path] >= 0) {
            path = path + ':' + String(__pathMap[path]);
            //console.log(path, String(__pathMap[key]));
            __pathMap[key]++;
            //console.log(path, __pathMap[key]);
        } else {
            __pathMap[path] = 0;
        }
        return path;
    };

    var __parserBinders = function(__mc__binderData, __mc__isBindObserve, key, val) {
        if (__mc_T_binders.hasOwnProperty(key)) {
            __mc__isBindObserve = true;
            __mc__binderData.push({
                attrName: key,
                value: val
            });
        }
        return __mc__isBindObserve;
    };

    var __bindBinder = function(__mc__new_el, __mc__attr, __mc__isBindObserve, __mc__binderData) {
        if (!__mc__isBindObserve) {
            var __mc__attr__keys = __objectKeys(__mc__attr);
            __each(__mc__attr__keys, function(attr) {
                if (attr.indexOf('on-') === 0) {
                    __mc__isBindObserve = true;
                }
            });
        }
        if (__mc__isBindObserve || __mc_T_components[__mc__new_el.tagName]) {
            __mc__new_el.bindTemplate(__mc__observe);
        }

        if (__mc__isBindObserve) {
            for (var __mc_i = 0, __mc_len = __mc__binderData.length; __mc_i < __mc_len; __mc_i++) {
                var __mc_v = __mc__binderData[__mc_i];
                __mc__new_el.bindBinder(__mc_v.attrName, __mc_v.value);
            }
        }
    };

    (function(scope, tree) { // startTree 0

        // <div/>
        var __mc__children_0 = [],
            __mc__attr = {},
            __mc__isBindObserve = false,
            __mc__binderData = [];
        __mc__attr['key'] = __getPath('.0');
        (function(scope, tree) { // startTree 1

            // <h1/>
            var __mc__children_1 = [],
                __mc__attr = {},
                __mc__isBindObserve = false,
                __mc__binderData = [];
            __mc__attr['key'] = __getPath('.0.1');
            (function(scope, tree) { // startTree 2

                tree.push('I am the popUpView');
            })(scope, __mc__children_1); // endTree 2
            var __mc__new_el = new __mc_T_El('h1', __mc__attr, __mc__children_1);
            __bindBinder(__mc__new_el, __mc__attr, __mc__isBindObserve, __mc__binderData);
            tree.push(__mc__new_el);
            // <h1/>
            var __mc__children_3 = [],
                __mc__attr = {},
                __mc__isBindObserve = false,
                __mc__binderData = [];
            __mc__attr['key'] = __getPath('.0.3');
            (function(scope, tree) { // startTree 4

                var __mc__rp__key_0;
                __mc__rp__key_0 = scope.id;
                if (__mc__rp__key_0 == undefined) {
                    __mc__rp__key_0 = '';
                }
                tree.push("My id is " + __mc__rp__key_0 + "");
            })(scope, __mc__children_3); // endTree 4
            var __mc__new_el = new __mc_T_El('h1', __mc__attr, __mc__children_3);
            __bindBinder(__mc__new_el, __mc__attr, __mc__isBindObserve, __mc__binderData);
            tree.push(__mc__new_el);
            // <a href="javascript:;"  mc-on-click="backClick" />
            var __mc__children_5 = [],
                __mc__attr = {},
                __mc__isBindObserve = false,
                __mc__binderData = [];
            __mc__attr['href'] = 'javascript:;';
            __mc__attr['on-click'] = 'backClick';
            __mc__attr['key'] = __getPath('.0.5');
            (function(scope, tree) { // startTree 6

                tree.push(' <=Back');
            })(scope, __mc__children_5); // endTree 6
            var __mc__new_el = new __mc_T_El('a', __mc__attr, __mc__children_5);
            __bindBinder(__mc__new_el, __mc__attr, __mc__isBindObserve, __mc__binderData);
            tree.push(__mc__new_el);
            // <br/>
            var __mc__children_7 = [],
                __mc__attr = {},
                __mc__isBindObserve = false,
                __mc__binderData = [];
            __mc__attr['key'] = __getPath('.0.7');
            var __mc__new_el = new __mc_T_El('br', __mc__attr, __mc__children_7);
            __bindBinder(__mc__new_el, __mc__attr, __mc__isBindObserve, __mc__binderData);
            tree.push(__mc__new_el);
            // <a href="javascript:;"  mc-on-click="closeClick" />
            var __mc__children_8 = [],
                __mc__attr = {},
                __mc__isBindObserve = false,
                __mc__binderData = [];
            __mc__attr['href'] = 'javascript:;';
            __mc__attr['on-click'] = 'closeClick';
            __mc__attr['key'] = __getPath('.0.9');
            (function(scope, tree) { // startTree 9

                tree.push('Close');
            })(scope, __mc__children_8); // endTree 9
            var __mc__new_el = new __mc_T_El('a', __mc__attr, __mc__children_8);
            __bindBinder(__mc__new_el, __mc__attr, __mc__isBindObserve, __mc__binderData);
            tree.push(__mc__new_el);
            // <br/>
            var __mc__children_10 = [],
                __mc__attr = {},
                __mc__isBindObserve = false,
                __mc__binderData = [];
            __mc__attr['key'] = __getPath('.0.11');
            var __mc__new_el = new __mc_T_El('br', __mc__attr, __mc__children_10);
            __bindBinder(__mc__new_el, __mc__attr, __mc__isBindObserve, __mc__binderData);
            tree.push(__mc__new_el);
            // <br/>
            var __mc__children_11 = [],
                __mc__attr = {},
                __mc__isBindObserve = false,
                __mc__binderData = [];
            __mc__attr['key'] = __getPath('.0.13');
            var __mc__new_el = new __mc_T_El('br', __mc__attr, __mc__children_11);
            __bindBinder(__mc__new_el, __mc__attr, __mc__isBindObserve, __mc__binderData);
            tree.push(__mc__new_el);
            // <br/>
            var __mc__children_12 = [],
                __mc__attr = {},
                __mc__isBindObserve = false,
                __mc__binderData = [];
            __mc__attr['key'] = __getPath('.0.15');
            var __mc__new_el = new __mc_T_El('br', __mc__attr, __mc__children_12);
            __bindBinder(__mc__new_el, __mc__attr, __mc__isBindObserve, __mc__binderData);
            tree.push(__mc__new_el);
            // <br/>
            var __mc__children_13 = [],
                __mc__attr = {},
                __mc__isBindObserve = false,
                __mc__binderData = [];
            __mc__attr['key'] = __getPath('.0.17');
            var __mc__new_el = new __mc_T_El('br', __mc__attr, __mc__children_13);
            __bindBinder(__mc__new_el, __mc__attr, __mc__isBindObserve, __mc__binderData);
            tree.push(__mc__new_el);
            // <a href="javascript:;"  mc-on-click="openClick" />
            var __mc__children_14 = [],
                __mc__attr = {},
                __mc__isBindObserve = false,
                __mc__binderData = [];
            __mc__attr['href'] = 'javascript:;';
            __mc__attr['on-click'] = 'openClick';
            __mc__attr['key'] = __getPath('.0.19');
            (function(scope, tree) { // startTree 15

                tree.push('open a subView');
            })(scope, __mc__children_14); // endTree 15
            var __mc__new_el = new __mc_T_El('a', __mc__attr, __mc__children_14);
            __bindBinder(__mc__new_el, __mc__attr, __mc__isBindObserve, __mc__binderData);
            tree.push(__mc__new_el);
        })(scope, __mc__children_0); // endTree 1
        var __mc__new_el = new __mc_T_El('div', __mc__attr, __mc__children_0);
        __bindBinder(__mc__new_el, __mc__attr, __mc__isBindObserve, __mc__binderData);
        tree.push(__mc__new_el);
    })(scope, __mc__children_0); // endTree 0


    if (__mc__children_0.length === 1 && __mc__children_0[0].render) {
        var virtualDom = __mc__children_0[0];
    } else {
        var virtualDom = new __mc_T_El('mc-vd', {}, __mc__children_0);
    }

    var templateDefined = {
        'virtualDom': virtualDom
    };
    return templateDefined;
};


/*****************
 ** WEBPACK FOOTER
 ** ./js/src/tpl/popTest.html
 ** module id = 6
 ** module chunks = 0
 **/